export enum ClassNamesScheduleModel {
  TITLE_EXPAND = 'Expand All',
  TITLE_COLLAPSED = 'Collapse All',
  TITLE_REFRESH = 'REFRESH',
  ICON_EXPAND = 'fa-arrow-up-right-and-arrow-down-left-from-center',
  ICON_COLLAPSE = 'fa-arrow-down-left-and-arrow-up-right-to-center'
}
